import { Dtos, IndemnityStatus } from "@inrev/common";
import { Icon, PartialIndicator, Spinner, Text } from "@portal/components/primitives";
import { FC } from "react";

type ExtendedIndemnityStatus = IndemnityStatus | "incomplete";

const indemnityStatusMap: Record<ExtendedIndemnityStatus, string> = {
	incomplete: "Not up to date",
	pending: "Not up to date",
	review: "In review",
	complete: "Up to date",
};

const AdminIndemnityAgreementStatusIconMap: Record<ExtendedIndemnityStatus, React.ReactNode> = {
	incomplete: <Icon type="x-mark" size="small" color="danger" />,
	pending: <PartialIndicator active className="mt-[2px]" />,
	review: <PartialIndicator active className="mt-[2px]" />,
	complete: <Icon type="check-circle" size="small" color="confirm" />,
};

export type AdminAccountIndemnityAgreementStatusProps = {
	latestIndemnityAgreement?: Dtos.SuretyAccount.IndemnityAgreement.Get.Response | null;
	isLoading: boolean;
};

export const AdminAccountIndemnityAgreementStatus: FC<
	AdminAccountIndemnityAgreementStatusProps
> = ({ latestIndemnityAgreement, isLoading }) => {
	const status = latestIndemnityAgreement?.status ?? "incomplete";

	return (
		<div
			data-testid="admin-account-indemnity-status"
			className="flex items-center space-x-[7px] min-w-fit"
		>
			{isLoading ? (
				<Spinner size="md" />
			) : (
				<>
					{AdminIndemnityAgreementStatusIconMap[status]}
					<Text type="body" color="secondary" className="italic">
						{indemnityStatusMap[status]}
					</Text>
				</>
			)}
		</div>
	);
};
